export const APP_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL,
  STORAGE_ACCOUNT_NAME: process.env.REACT_APP_STORAGE_ACCOUNT_NAME,
};
